var styles = {"button":"bc-button__button","outline":"bc-button__outline","danger":"bc-button__danger","primary":"bc-button__primary","secondary":"bc-button__secondary","small":"bc-button__small"};

export { styles as default };
